import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { Box, Typography, Tooltip } from '@mui/material';
import { CalendarDate, } from '@internationalized/date';
import CustomDatePicker from '../../../common_components/daterangepicker/CustomDatePicker';
function toCalendarDate(iso) {
    const d = typeof iso === 'string' ? new Date(iso) : iso;
    return new CalendarDate(d.getUTCFullYear(), d.getUTCMonth() + 1, d.getUTCDate());
}
function calendarDateToIso(cd) {
    const mm = String(cd.month).padStart(2, '0');
    const dd = String(cd.day).padStart(2, '0');
    return `${cd.year}-${mm}-${dd}`;
}
const PeriodPicker = ({ periodStart, periodEnd, onApply, disabled, disabledReason, saving, }) => {
    const [start, setStart] = useState(toCalendarDate(periodStart));
    const [end, setEnd] = useState(toCalendarDate(periodEnd));
    // Keep local state synced when the parent's period changes (e.g. after
    // navigating to a different report).
    useEffect(() => {
        setStart(toCalendarDate(periodStart));
        setEnd(toCalendarDate(periodEnd));
    }, [periodStart, periodEnd]);
    const handleApply = (data) => {
        if (!data?.mainRange)
            return;
        const newStart = calendarDateToIso(data.mainRange.start);
        const newEnd = calendarDateToIso(data.mainRange.end);
        onApply({ start: newStart, end: newEnd });
    };
    const wrapper = (_jsxs(Box, { sx: {
            minWidth: 200,
            opacity: disabled ? 0.6 : 1,
            pointerEvents: disabled ? 'none' : 'auto',
        }, children: [_jsx(CustomDatePicker, { value: { start, end }, onChange: (range) => {
                    if (range) {
                        setStart(range.start);
                        setEnd(range.end);
                    }
                }, onApply: handleApply, comparison: false, maxPastYears: 5, size: "compact", disabled: disabled || saving }), saving && (_jsx(Typography, { sx: { fontSize: 11, color: '#475467', mt: 0.5 }, children: "Re-running audit with new dates\u2026" }))] }));
    if (disabled && disabledReason) {
        return (_jsx(Tooltip, { title: disabledReason, placement: "bottom", children: wrapper }));
    }
    return wrapper;
};
export default PeriodPicker;
